import { render, staticRenderFns } from "./VerifyPage.vue?vue&type=template&id=e154b574&scoped=true&"
import script from "./VerifyPage.vue?vue&type=script&lang=js&"
export * from "./VerifyPage.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPage.vue?vue&type=style&index=0&id=e154b574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e154b574",
  null
  
)

export default component.exports